import {
  getRelativeFontSize,
  inputLabelRequiredColor,
  mediumFont,
  regularFont,
  theme,
} from "../../../utils/styles";

const productManagementStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 2,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  scrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": { width: "5px" },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: { height: "calc(100vh - 220px)" },
    [theme.breakpoints.down("md")]: { height: "calc(100vh - 235px)" },
    [theme.breakpoints.down("sm")]: { height: "calc(100vh - 222px)" },
  },
  bannersContent: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  bannerSlot: {
    display: "flex",
    flexDirection: "column",
    minHeight: 140,
    p: 1.5,
    border: "1px solid rgba(255, 255, 255, 0.2)",
    [theme.breakpoints.down("sm")]: {
      minHeight: 120,
    },
  },
  bannerSlotTitle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    color: "rgba(255, 255, 255, 0.85)",
    letterSpacing: "0.03em",
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: { fontSize: "35px" },
  },
  sectionCard: {
    p: 2.5,
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.18)",
    background:
      "linear-gradient(152deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 50%, rgba(144, 83, 246, 0.04) 100%)",
    boxShadow:
      "0 4px 24px rgba(0,0,0,0.12), 0 1px 0 rgba(255,255,255,0.04) inset",
    mb: 3,
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      borderColor: "rgba(255, 255, 255, 0.25)",
      boxShadow:
        "0 6px 28px rgba(0,0,0,0.15), 0 1px 0 rgba(255,255,255,0.06) inset",
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
    flexShrink: 0,
  },
  sectionBodyRow: {
    display: "flex",
    flexDirection: "row" as const,
    gap: 2,
    alignItems: "stretch",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column" as const,
    },
  },
  dropzoneWrap: {
    flex: "1 1 50%",
    minWidth: 0,
    [theme.breakpoints.down("md")]: {
      flex: "1 1 auto",
    },
  },
  dropzone: {
    border: "2px dashed rgba(255, 255, 255, 0.35)",
    borderRadius: "12px",
    height: 200,
    flex: 1,
    minWidth: 0,
    p: 1,
    textAlign: "center" as const,
    cursor: "pointer",
    transition: "all 0.22s ease",
    background: "rgba(144, 83, 246, 0.06)",
    position: "relative" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      borderColor: "rgba(144, 83, 246, 0.7)",
      background: "rgba(144, 83, 246, 0.12)",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 100,
    },
  },
  dropzoneWithPreview: {
    borderStyle: "solid",
    borderColor: "rgba(144, 83, 246, 0.4)",
    padding: 0,
    overflow: "hidden",
  },
  dropzoneText: {
    ...regularFont,
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: getRelativeFontSize(1),
    pointerEvents: "none" as const,
  },
  dropzoneIcon: {
    fontSize: "32px",
    color: "rgba(144, 83, 246, 0.5)",
    mb: 0.5,
    pointerEvents: "none" as const,
  },
  previewInside: {
    width: "100%",
    height: "100%",
    minHeight: 100,
    position: "relative" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain" as const,
    borderRadius: "14px",
  },
  removeImageBtn: {
    position: "absolute" as const,
    top: 6,
    right: 6,
    minWidth: 28,
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "rgba(244, 67, 54, 0.9)",
    color: "#fff",
    boxShadow: "0 1px 8px rgba(0,0,0,0.3)",
    "&:hover": {
      background: "#f44336",
      transform: "scale(1.05)",
    },
    zIndex: 2,
  },
  linkFieldWrap: {
    flex: "1 1 auto",
    minHeight: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column" as const,
  },
  linkFieldCard: {
    mb: 1.5,
  },
  linkFieldLabel: {
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    color: "rgba(255, 255, 255, 0.9)",
    mb: 0.75,
    letterSpacing: "0.02em",
  },
  nameFieldHidden: {
    display: "none",
  },
  textField: {
    width: "100%",
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "8px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": { border: 0 },
        backgroundColor: "rgba(255, 255, 255, 0.06)",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid rgba(144, 83, 246, 0.4)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "8px 12px",
      color: "#FFFFFF",
      fontSize: getRelativeFontSize(1),
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.45)",
      },
    },
  },
  nameField: {
    color: "#FFFFFF",
    marginLeft: "6px",
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    "& .MuiFormLabel-asterisk": { color: inputLabelRequiredColor },
    [theme.breakpoints.down("sm")]: { fontSize: getRelativeFontSize(2) },
  },
  saveBtnWrap: {
    mt: 1,
    flexShrink: 0,
    alignSelf: "flex-start",
  },
  saveBtn: {
    borderRadius: "8px",
    background: "linear-gradient(135deg, #9053F6 0%, #7C3AED 100%)",
    color: "#fff",
    px: 2,
    py: 0.75,
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    boxShadow: "0 2px 10px rgba(144, 83, 246, 0.35)",
    "&:hover": {
      background: "linear-gradient(135deg, #9F67F8 0%, #8B5CF6 100%)",
      boxShadow: "0 4px 14px rgba(144, 83, 246, 0.45)",
    },
    "&:disabled": {
      background: "rgba(144, 83, 246, 0.35)",
      color: "rgba(255,255,255,0.5)",
    },
  },
  addSectionBtn: {
    borderRadius: "8px",
    border: "2px dashed rgba(255, 255, 255, 0.35)",
    color: "rgba(255, 255, 255, 0.85)",
    py: 1,
    px: 2,
    "&:hover": {
      borderColor: "#9053F6",
      backgroundColor: "rgba(144, 83, 246, 0.15)",
      color: "#fff",
    },
  },
  removeSectionBtn: {
    ...regularFont,
    color: "#f44336",
    fontSize: getRelativeFontSize(1),
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.1)",
    },
  },
} as const;

export default productManagementStyles;
